import { render, staticRenderFns } from "./TotalBoardWebpart.vue?vue&type=template&id=022d4c10"
import script from "./TotalBoardWebpart.ts?vue&type=script&lang=ts&external"
export * from "./TotalBoardWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports